"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FUND_DEFAULT: "@@assetUpload/fund-default",
  IMPACT_DEFAULT: "@@assetUpload/impact-default",
  PRINTBRIGE_DEFAULT: "@@assetUpload/printbridge-default",
  UPLOAD_PROFILE: "@@assetUpload/upload-profile",
  REMOVE_PROFILE: "@@assetUpload/remove-profile",
  RESET_PROFILE: "@@assetUpload/reset-profile",
  UPLOAD_VCARD: "@@assetUpload/upload-vcard",
  REMOVE_VCARD: "@@assetUpload/remove-vcard",
  RESET_VCARD: "@@assetUpload/reset-vcard",
  UPLOAD_RESOURCE: "@@assetUpload/upload-resource",
  UPLOAD_CROPPED_IMAGE: "@@assetUpload/upload-cropped-image",
  UPLOAD_IMAGE_FUND: "@@assetUpload/upload-image-fund",
  UPLOAD_IMPACT: "@@assetUpload/upload-impact",
  RESET_CROPPED_IMAGE: "@@assetUpload/reset-upload-crop",
  RESET_UPLOAD_IMPACT: "@@assetUpload/reset-upload-impact",
  RESET: "@@assetUpload/reset",
  SUCCESS: "@@assetUpload/success",
  ERROR: "@@assetUpload/error"
};
exports.actionTypes = actionTypes;